// @ts-strict-ignore
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'absoluteValue' })
export class AbsoluteValuePipe implements PipeTransform {
  transform(value) {
    return Math.abs(value);
  }
}
